// Financing page specific translations - English
export const financingEn = {
  hero: {
    title: 'Financing',
    description:
      'Complete the form to request information about our financing options.',
  },
  form: {
    firstName: 'First name',
    lastName: 'Last name',
    email: 'Email',
    phone: 'Phone',
    rut: 'RUT',
    birthDate: 'Date of Birth',
    employmentType: 'Employment Type',
    monthlyIncome: 'Monthly Net Income',
    vehicleInterest: 'Vehicle of interest',
    vehicleSearchPlaceholder: 'Search vehicle',
    noVehiclesAvailable: 'No vehicles available currently',
    downPayment: 'Down Payment',
    message: 'Message or additional information',
    submit: 'Send Information',
  },
  employmentTypes: {
    employeeNonProfessional: 'Employee (Non-professional)',
    employeeProfessional: 'Employee (Professional)',
    selfEmployedNonProfessional: 'Self-employed (Non-professional)',
    selfEmployedProfessional: 'Self-employed (Professional)',
    retired: 'Retired',
    other: 'Other',
  },
  info: {
    optionsTitle: 'Financing Options',
    benefitsTitle: 'Benefits of our financing',
    benefitsList: {
      item1: 'Competitive interest rates',
      item2: 'Flexible terms from 12 to 60 months',
      item3: 'Quick approval',
      item4: 'Minimal requirements',
    },
    requirementsTitle: 'Basic requirements',
    requirementsList: {
      item1: 'Valid official identification',
      item2: 'Proof of address',
      item3: 'Proof of income',
      item4: 'Favorable credit history',
    },
    directContactTitle: 'Direct Contact',
    emailLabel: 'Email',
    phoneLabel: 'Phone',
  },
  embed: {
    infoTitle: 'Financing options',
    benefits: ['Quick approval', 'Competitive rates', 'Flexible terms', 'No fine print'],
    requirementsTitle: 'Requirements',
    requirements: ['ID card', 'Pay stub', 'Proof of address', 'Minimum work seniority'],
    contactTitle: 'Direct contact',
  },
};
